import DarkButton from "components/actions/DarkButton";
import PenEditIcon from "components/icons/PenEditIcon";
import { useNavigate } from "react-router-dom";

const Details = ({ user }) => {
  const navigate = useNavigate();

  const detailItems = [
    { label: "Email address", value: user?.email },
    { label: "Contact phone", value: user?.phone },
    { label: "Gender", value: user?.gender || "" },
    {
      label: "Location",
      value: user?.address,
    },
    {
      label: "Age",
      value: user?.dob
        ? new Date().getUTCFullYear() - new Date(user?.dob).getUTCFullYear()
        : "-",
    },
    { label: "Family relationship", value: user?.familyRelationship || "" },
  ];

  return (
    <div>
      {detailItems?.map((item, index) => (
        <div
          key={index}
          className="flex justify-between items-center border-b border-gray-200 py-4"
        >
          <p className="text-[#A3AED0] text-[16px]">{item?.label}</p>
          <p
            className={`text-gray-800 text-[16px] dark:text-white ${
              item?.label !== "Email address" &&
              item?.label !== "Location" &&
              "capitalize"
            }`}
          >
            {item?.value}
          </p>
        </div>
      ))}
      <div className="mt-6">
        <DarkButton
          onClick={() => navigate(`/admin/people/${user?.id}/edit`)}
          customClass={"px-2 md:px-2"}
          size={"lg"}
        >
          <span>
            <PenEditIcon className="mr-2 text-white" /> Edit profile
          </span>
        </DarkButton>
      </div>
    </div>
  );
};

export default Details;
